import { render, staticRenderFns } from "./custConvertChannelSourceNewListCmr.vue?vue&type=template&id=4aaa2296&scoped=true&"
import script from "./custConvertChannelSourceNewListCmr.vue?vue&type=script&lang=js&"
export * from "./custConvertChannelSourceNewListCmr.vue?vue&type=script&lang=js&"
import style0 from "./custConvertChannelSourceNewListCmr.vue?vue&type=style&index=0&id=4aaa2296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa2296",
  null
  
)

export default component.exports